// ======================================================================
// File Name       : CourseDistributionUsageList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { Table } from 'react-bootstrap';
import {
  CONTENT_DISTRIBUTION_CONTENT_TYPE
} from '../../constants/ContentDistributionConstant';
import { getItemBoxName } from '../../utils/index';
import TableHead, { setSortState } from '../TableHead';

const CourseDistributionUsageList = ({ courseDistributionUsage, handleSortState, dataSort }) => {
  const thead = [
    { title: 'コース名', sortBy: 0 },
    { title: 'コンテンツ種別', sortBy: 1 },
    { title: '配布コンテンツ名', sortBy: 2 },
    { title: '実行回数', sortBy: 3, width: 120 },
    { title: 'ユニーク実行ユーザー数', sortBy: 4 },
  ];
  let data = thead;
  if (dataSort) {
    const sortBy = dataSort.distributionUsedCourseSortType;
    const sortState = dataSort.ascendingDescendingSort;
    data = setSortState(thead, sortBy, sortState);
  }

  const distributionServiceList =
  courseDistributionUsage && courseDistributionUsage.distributionCourseList &&
  courseDistributionUsage.distributionCourseList.map((courseDistribution, index) => (
      <tr key={index}>
        <td>{courseDistribution.courseName}</td>
        <td>
          {getItemBoxName(CONTENT_DISTRIBUTION_CONTENT_TYPE, courseDistribution.contentType)}
        </td>
        <td>{courseDistribution.itemName}</td>
        <td className="text-right">{courseDistribution.usedCount}</td>
        <td className="text-right">{courseDistribution.uniqueUsedUserNum}</td>
      </tr>
    ));
  // }

  return (
    <div>
      <Table striped hover>
        <thead>
          <TableHead data={data} handleSortState={handleSortState} />
        </thead>
        <tbody>{distributionServiceList}</tbody>
      </Table>
    </div>
  );
};

export default CourseDistributionUsageList;
